const topicsList = [
  {
    type: "section",
    category: [],
    formNumber: null,
    title: "Property Types",
  },
  {
    type: "topic",
    topicId: "singleFamilyBC",
    title: "Single Family Residential (Resale)",
  },
  {
    type: "topic",
    topicId: "condoResaleBC",
    title: "Residential Condo (Resale)",
  },
  {
    type: "topic",
    topicId: "preconcondo",
    title: "Pre-Construction (Condos)",
  },
  {
    type: "topic",
    topicId: "FSBO",
    title: "For Sale by Owner (Residential Resale)",
  },
  {
    type: "topic",
    topicId: "mobileManufactured",
    title: "Mobile, Manufactured, and Modular Home",
  },

  {
    type: "topic",
    topicId: "foreclosures",
    title: "Foreclosures",
  },
  {
    type: "topic",
    topicId: "assignment",
    title: "Assignments (Pre-Construction)",
  },
  {
    type: "topic",
    topicId: "cottage",
    title: "Cottage Property",
  },
  {
    type: "topic",
    topicId: "indigenousLand",
    title: "Purchase on First Nations Land (Leased Land)",
  },
  {
    type: "section",
    category: [],
    formNumber: null,
    title: "Additional Topics",
  },
  {
    type: "topic",
    topicId: "taxes",
    title: "All About Taxes",
  },
  {
    type: "topic",
    topicId: "commission",
    title: "Commission Related Practices",
  },
  {
    type: "topic",
    topicId: "foreclosuresTopic",
    title: "Foreclosures",
  },
  {
    type: "topic",
    topicId: "gst",
    title: "GST",
  },
  {
    type: "topic",
    topicId: "inspection",
    title: "Inspections",
  },
  {
    type: "topic",
    topicId: "landAssembly",
    title: "Land Assembly",
  },
  {
    type: "topic",
    topicId: "newconstruction",
    title: "New Construction",
  },
  {
    type: "topic",
    topicId: "multipleOffers",
    title: "Multiple & Referential Offers",
  },
  {
    type: "topic",
    topicId: "oilTanks",
    title: "Oil Tanks",
  },
  {
    type: "topic",
    topicId: "probate",
    title: "Probate Estate Sales",
  },
  {
    type: "topic",
    topicId: "poa",
    title: "Power of Attorneys & Corporate Clients",
  },
  {
    type: "topic",
    topicId: "radon",
    title: "Radon Gas",
  },
  {
    type: "topic",
    topicId: "tenants",
    title: "Tenants - What You Need To Know",
  },
];

export default topicsList;
